import { useEffect } from 'react'

export default function useSetTrrebDlv(
  isAgreementMismatched: boolean | undefined
) {
  useEffect(() => {
    if (isAgreementMismatched) {
      window.dataLayer.push({
        termsType: isAgreementMismatched
          ? 'noterms_accepted'
          : 'trrebterms_accepted'
      })
    }
  }, [isAgreementMismatched])
}
